import React, { Component } from 'react';

import appendQuery from 'append-query';
// eslint-disable-next-line lodash/import-scope
import { get } from 'lodash';
import PropTypes from 'prop-types';

import { Button, Heading } from '@nerdwallet/currency';
import { iconUri } from '@nerdwallet/nw-client-lib/cdn';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';

import ImageSizes from '../../config/images/imageSizes';
import transformToMRTInputs from '../../lib/transform-to-mrt-inputs';

// CSS
require('./rate-table-cta.less');

class RateTableCta extends Component {
  static renderImpression() {
    const trackingName = 'mortgages-embedded-reco';

    return (
      <ElementImpression
        id={`${trackingName}=mrt`}
        elementName={trackingName}
        elementPosition={0}
        sectionCategory="embedded-reco"
      />
    );
  }

  getUrl() {
    return appendQuery(this.props.href, {
      ...transformToMRTInputs(this.props.data),
      bypass: true,
      trk: `${this.props.trackingFormName}_embedreco_mrt`,
    });
  }

  getSummaryText() {
    const { summaryText } = this.props;
    if (summaryText) {
      return summaryText;
    }

    return `Get personalized mortgage rates for ${get(
      this.props,
      'data.inputs.purchaseAddress.city'
    )}, ${get(this.props, 'data.inputs.purchaseAddress.state')}`;
  }

  renderCTA() {
    return (
      <div className="rate-table-cta-button">
        <Button>{this.props.buttonText}</Button>
      </div>
    );
  }

  renderHeader() {
    return (
      <Heading level="4" className="rate-table-cta-header">
        {this.props.headerText}
      </Heading>
    );
  }

  renderImage() {
    return (
      <img
        className="rate-table-cta-img"
        {...ImageSizes.largeIcon.measures}
        src={this.props.img}
        alt=""
      />
    );
  }

  renderSummary() {
    return <p className="rate-table-cta-summary">{this.getSummaryText()}</p>;
  }

  render() {
    return (
      <div className="rate-table-cta">
        <a className="rate-table-cta-link" href={this.getUrl()} target="_blank">
          {this.renderHeader()}
          {this.renderImage()}
          {this.renderSummary()}
          {RateTableCta.renderImpression()}
          {this.renderCTA()}
        </a>
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
RateTableCta.displayName = 'RateTableCta';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
RateTableCta.propTypes = {
  data: PropTypes.object.isRequired, // entire reducer
  // UI props
  buttonText: PropTypes.string,
  headerText: PropTypes.string,
  href: PropTypes.string,
  img: PropTypes.string,
  summaryText: PropTypes.string,
  trackingFormName: PropTypes.string.isRequired,
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
RateTableCta.defaultProps = {
  buttonText: 'Get started',
  headerText: 'See latest mortgage rates',
  href: '/mortgages/mortgage-rates',
  img: iconUri('iPad_graph'),
  summaryText: null,
};

export default RateTableCta;
